<template>
  <ScreenAdapter>
    <div class="screen-container">
      <div class="ys-head">工业元数工业互联网平台</div>
      <div class="ys-body">
        <div class="ys-body-left">
          <div class="ys-body-title">
            <p>机加&装备一站式供需对接</p>
            <img src="../assets/images/ys/dots.png" width="24px" alt="" />
          </div>
          <div class="ys-body-num">
            <div class="ys-body-num-ul">
              <div class="ys-body-num-li">
                <img src="../assets/images/ys/numicon.png" width="69" alt="" />
                <div class="ys-body-num-li-r">
                  <h4>采购商</h4>
                  <div><span>3728</span><span>家</span></div>
                </div>
              </div>
              <div class="ys-body-num-li">
                <img src="../assets/images/ys/numicon.png" width="69" alt="" />
                <div class="ys-body-num-li-r">
                  <h4>供应商</h4>
                  <div><span>23962</span><span>家</span></div>
                </div>
              </div>
            </div>
            <div style="height: 30px"></div>
            <div class="ys-body-num-ul">
              <div class="ys-body-num-li">
                <img src="../assets/images/ys/numicon.png" width="69" alt="" />
                <div class="ys-body-num-li-r">
                  <h4>订单数量</h4>
                  <div><span>26039</span><span>个</span></div>
                </div>
              </div>
              <div class="ys-body-num-li">
                <img src="../assets/images/ys/numicon.png" width="69" alt="" />
                <div class="ys-body-num-li-r">
                  <h4>撮合交易金额</h4>
                  <div>
                    <span style="font-size: 25px">419346</span><span>万元</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ys-body-order">
            <div class="ys-body-order-head">
              <div class="ys-body-order-li">供需产品</div>
              <div class="ys-body-order-li">工艺</div>
              <div class="ys-body-order-li">采购数量</div>
              <div class="ys-body-order-li">截止日期</div>
            </div>
            <vue-seamless-scroll
              :data="orderList"
              class="seamless-warp"
              :class-option="classOption"
            >
              <div
                class="ys-body-order-ul"
                v-for="(item, index) in orderList"
                :class="index % 2 != 1 ? '' : 'ys-body-order-ul-active'"
                :key="index"
              >
                <div class="ys-body-order-li">{{ item.productNames }}</div>
                <div class="ys-body-order-li">
                  {{ item.processTechnicText }}
                </div>
                <div class="ys-body-order-li">
                  {{ item.numberContent }}
                  {{ item.firstUnit }}
                </div>
                <div class="ys-body-order-li" style="color: #19cc96">
                  {{
                    item.quotationDeadline
                      ? item.quotationDeadline.substr(0, 10)
                      : ""
                  }}
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="ys-body-middle">
          <div class="ys-body-middle-honor">
            <div class="ys-body-middle-honor-ul">
              <div class="ys-body-middle-honor-li">
                <span>国家级服务型制造示范平台</span>
              </div>
              <div style="width: 77px"></div>
              <div class="ys-body-middle-honor-li">
                <span>国家中小企业公共服务示范平台</span>
              </div>
            </div>
            <div style="height: 20px"></div>
            <div class="ys-body-middle-honor-ul">
              <div class="ys-body-middle-honor-li">
                <span>江苏省双跨工业互联网平台</span>
              </div>
            </div>
          </div>
          <YsMap></YsMap>
          <div class="ys-body-middle-mapNum">
            <div class="ys-body-middle-mapNum-ul">
              <div class="ys-body-middle-mapNum-img">
                <img src="../assets/images/ys/menu.png" width="12" alt="" />
              </div>
              <div class="ys-body-middle-mapNum-li">
                <h4>江苏</h4>
                <p><span>9838</span><span>家</span></p>
              </div>
              <div class="ys-body-middle-mapNum-li">
                <h4>山东</h4>
                <p><span>1283</span><span>家</span></p>
              </div>
            </div>
            <div class="ys-body-middle-mapNum-ul">
              <div class="ys-body-middle-mapNum-img"></div>
              <div class="ys-body-middle-mapNum-li">
                <h4>河北</h4>
                <p><span>2542</span><span>家</span></p>
              </div>
              <div class="ys-body-middle-mapNum-li">
                <h4>广东</h4>
                <p><span>2000</span><span>家</span></p>
              </div>
            </div>
            <div class="ys-body-middle-mapNum-ul">
              <div class="ys-body-middle-mapNum-img"></div>
              <div class="ys-body-middle-mapNum-li">
                <h4>浙江</h4>
                <p><span>2500</span><span>家</span></p>
              </div>
              <div class="ys-body-middle-mapNum-li">
                <h4>安徽</h4>
                <p><span>1590</span><span>家</span></p>
              </div>
            </div>
            <div class="ys-body-middle-mapNum-ul">
              <div class="ys-body-middle-mapNum-img"></div>
              <div class="ys-body-middle-mapNum-li">
                <h4>其他</h4>
                <p><span>4975</span><span>家</span></p>
              </div>
              <div class="ys-body-middle-mapNum-li"></div>
            </div>
          </div>
        </div>
        <div class="ys-body-right">
          <div class="ys-body-title">
            <p>智改数转网联一站式服务</p>
            <img src="../assets/images/ys/dots.png" width="24px" alt="" />
          </div>
          <div class="ys-zd">
            <div class="ys-zd-item">
              <p><span>2263</span><span>家</span></p>
              <img src="../assets/images/ys/fubg.png" width="118" alt="" />
              <h4>咨询诊断</h4>
            </div>
            <div class="ys-zd-item">
              <p><span>1308</span><span>家</span></p>
              <img src="../assets/images/ys/fubg.png" width="118" alt="" />
              <h4>转型实施</h4>
            </div>
            <div class="ys-zd-item">
              <p><span>185</span><span>家</span></p>
              <img src="../assets/images/ys/fubg.png" width="118" alt="" />
              <h4>生态合作</h4>
            </div>
          </div>
          <div class="ys-fa">
            <div class="ys-fa-bg">
              <img src="../assets/images/ys/piebg.png" width="220" alt="" />
            </div>
            <div id="fakf" style="height: 180px"></div>
            <div class="ys-fa-legend">
              <div class="ys-fa-legend-li li-1">
                <div></div>
                <p>研发设计</p>
              </div>
              <div class="ys-fa-legend-li li-2">
                <div></div>
                <p>生产制造</p>
              </div>
              <div class="ys-fa-legend-li li-3">
                <div></div>
                <p>经营管理</p>
              </div>
              <div class="ys-fa-legend-li li-4">
                <div></div>
                <p>营销服务</p>
              </div>
              <div class="ys-fa-legend-li li-5">
                <div></div>
                <p>供应链协同</p>
              </div>
              <div class="ys-fa-legend-li li-6">
                <div></div>
                <p>信息安全</p>
              </div>
            </div>
            <div class="ys-fa-title">方案开发</div>
          </div>
          <div class="ys-pics">
            <div class="ys-pics-main">
              <el-carousel
                :interval="3000"
                indicator-position="none"
                :loop="true"
              >
                <el-carousel-item
                  v-for="(item, index) in swiperList"
                  :key="index"
                >
                  <img :src="item.url" width="418" height="203" />
                  <div class="textDesc">
                    <p>{{ item.name }}</p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="ys-footer">
        <div class="ys-footer-title">智改数转用户案例</div>
        <div class="ys-footer-cases">
          <div class="ys-footer-cases-main"></div>
          <div style="width: 100%" v-if="showCases">
            <el-carousel
              :interval="10000"
              indicator-position="none"
              :loop="true"
              arrow="never"
            >
              <el-carousel-item v-for="(item, index) in caseList" :key="index">
                <div class="ys-footer-cases-ul">
                  <div
                    class="ys-footer-cases-li"
                    v-for="(v, i) in item"
                    :key="i"
                  >
                    <div class="ys-footer-cases-li-hy">
                      {{ v.hy }}
                    </div>
                    <div class="ys-footer-cases-li-name">
                      {{ v.name }}
                    </div>
                    <div class="ys-footer-cases-li-des">
                      {{ v.des }}
                    </div>
                    <div style="height: 28px"></div>
                    <el-carousel
                      :interval="5000"
                      indicator-position="none"
                      :loop="true"
                      arrow="never"
                      direction="vertical"
                    >
                      <el-carousel-item>
                        <div class="ys-footer-cases-li-img">
                          <img :src="v.img1" width="286" height="142" alt="" />
                        </div>
                      </el-carousel-item>
                      <el-carousel-item>
                        <div class="ys-footer-cases-li-img">
                          <img :src="v.img2" width="286" height="142" alt="" />
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </ScreenAdapter>
</template>
<script>
import axios from "axios";
import dayjs from "dayjs";
import ScreenAdapter from "../components/ScreenAdapter.vue";
import YsMap from "../components/Ys-Map.vue";
export default {
  components: {
    ScreenAdapter,
    YsMap,
  },
  computed: {
    classOption() {
      return {
        step: 0.4,
        limitMoveNum: 5,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000,
      };
    },
  },
  mounted() {
    this.chartPie();
    this.showCases = true;
    this.reloadCases();
    this.getDemandData();
  },
  data() {
    return {
      orderList: [],
      swiperList: [
        { name: "数智游学", url: require("../assets/images/ys/youxue.png") },
        { name: "数智人才培训", url: require("../assets/images/ys/wlaq.png") },
        { name: "机器人培训", url: require("../assets/images/ys/ys1.jpg") },
        { name: "数智人才培训", url: require("../assets/images/ys/ys3.jpg") },
        { name: "精益智造培训", url: require("../assets/images/ys/ys2.jpg") },
      ],
      showCases: false,
      caseList: [
        [
          {
            hy: "新材料行业",
            name: "汉华科技",
            des: "数据采集及设备管理、MES、ERP",
            img1: require("../assets/images/ys/hanhua1.jpg"),
            img2: require("../assets/images/ys/hanhua2.png"),
          },
          {
            hy: "汽车零部件行业",
            name: "江苏方兴",
            des: "MOM系统、ERP、设备数采、AGV集成",
            img1: require("../assets/images/ys/fx1.png"),
            img2: require("../assets/images/ys/fx2.png"),
          },
          {
            hy: "建筑行业",
            name: "博拓建材",
            des: "MES系统、ERP、数据采集",
            img1: require("../assets/images/ys/botuo1.png"),
            img2: require("../assets/images/ys/botuo2.png"),
          },
          {
            hy: "机械加工行业",
            name: "大洋精锻",
            des: "MES、ERP集成、OA",
            img1: require("../assets/images/ys/dy1.png"),
            img2: require("../assets/images/ys/dy2.png"),
          },
          {
            hy: "新能源行业",
            name: "双瑞风电",
            des: "能源管理平台、多基地数据集成",
            img1: require("../assets/images/ys/sr1.png"),
            img2: require("../assets/images/ys/sr2.png"),
          },
        ],
        [
          {
            hy: "汽车零部件行业",
            name: "阿现特",
            des: "MES系统、ERP、数据采集",
            img1: require("../assets/images/ys/axt1.png"),
            img2: require("../assets/images/ys/axt2.png"),
          },
          {
            hy: "汽车零部件行业",
            name: "大捷实业",
            des: "MES系统、ERP、数据采集",
            img1: require("../assets/images/ys/dj1.png"),
            img2: require("../assets/images/ys/dj2.jpg"),
          },
          {
            hy: "装备制造行业",
            name: "繁枫真空",
            des: "MES系统、ERP集成、OA、数据采集",
            img1: require("../assets/images/ys/ff1.png"),
            img2: require("../assets/images/ys/ff2.png"),
          },
          {
            hy: "汽车零部件行业",
            name: "景鸿汽车",
            des: "MES系统、数据采集、WMS系统",
            img1: require("../assets/images/ys/jh1.jpg"),
            img2: require("../assets/images/ys/jh2.png"),
          },
          {
            hy: "汽车零部件行业",
            name: "爱驰威",
            des: "数据采集及设备管理、MES、ERP",
            img1: require("../assets/images/ys/acw1.png"),
            img2: require("../assets/images/ys/acw2.png"),
          },
        ],
      ],
    };
  },
  methods: {
    async getDemandData() {
      const now = new dayjs().format("YYYY-MM-DD 00:00:00");
      const { data: ret } = await axios.post(
        "https://my.yccngx.com/api/ylt/bcard/portal/biz/gyysWebInquiry?current=1&size=50"
        // `https://www.515ugx.com/cos/order/list?current=1&size=100&offerEndDateForStart=${now}`
      );
      // console.log(ret.data.records);
      if (ret.data.records) {
        // console.log(ret.data.records);
        ret.data.records = ret.data.records.filter((item) => {
          if (
            new Date(item.quotationDeadline.replace(/-/g, "/")).valueOf() >=
            new Date().valueOf()
          ) {
            return item;
          }
        });
      }
      this.orderList = ret.data.records;
    },
    chartPie() {
      let container = document.getElementById("fakf");
      Highcharts.chart(container, {
        title: {
          text: "",
        },
        exporting: {
          enabled: false, // 完全禁用导出功能
        },
        credits: {
          enabled: false, // 完全隐藏版权信息
        },
        // 不生效，难顶
        // legend: {
        //   align: "right", // 右对齐
        //   verticalAlign: "middle", // 垂直居中
        //   layout: "vertical", // 垂直布局
        //   itemStyle: {
        //     fontSize: "14px",
        //   },
        //   symbolHeight: 14, // 图例符号高度
        //   symbolWidth: 14, // 图例符号宽度
        //   symbolRadius: 0, // 方形图例符号
        //   borderWidth: 1, // 边框宽度
        //   borderColor: "#ccc", // 边框颜色
        //   borderRadius: 5, // 边框圆角
        //   padding: 10, // 内边距
        //   itemMarginBottom: 5, // 图例项间距
        // },
        chart: {
          backgroundColor: null, // 设置整个图表区域的背景色
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 75,
          },
        },
        plotOptions: {
          pie: {
            center: ["30%", "35%"],
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: false,
            },
          },
        },
        series: [
          {
            name: "占比",
            colorByPoint: true,
            data: [
              {
                name: "研发设计",
                y: 60,
                color: "#2a9cff",
              },
              {
                name: "生产制造",
                y: 50,
                color: "#FF4069",
              },
              {
                name: "经营管理",
                y: 40,
                color: "#27e89e",
              },
              {
                name: "营销服务",
                y: 30,
                color: "#ffd938",
              },
              {
                name: "供应链协同",
                y: 20,
                color: "#8355f7",
              },
              {
                name: "信息安全",
                y: 10,
                color: "#55e1f7",
              },
            ],
          },
        ],
      });
    },
    reloadCases() {
      this.showCases = false;
      this.$nextTick(() => {
        this.showCases = true;
        let casetimer = setTimeout(() => {
          // 每隔10分钟刷新一下，不然图片切换不同步
          this.reloadCases();
          clearTimeout(casetimer);
        }, 600000);
      });
    },
  },
};
</script>
<style>
.ys-pics .el-carousel__container {
  height: 203px !important;
}
.ys-footer-cases-li .el-carousel__container {
  width: 286px !important;
  height: 142px !important;
}
</style>

<style lang="less" scoped>
* {
  user-select: none;
}
p,
h4 {
  margin: 0;
  padding: 0;
}
.screen-container {
  width: 100%;
  height: 100%;
  background-image: url(../assets/images/ys/bg.png);
  background-size: 101% 100%;
  background-repeat: no-repeat;
  position: relative;
  .ys-head {
    padding-left: 13px;
    font-family: "FZLanTingHeiS-DB1-GBK";
    height: 100px;
    line-height: 64px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 1.5px;
    font-weight: 400;
    background: linear-gradient(#ffffff, #78d9ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .ys-body {
    width: 100%;
    height: 605px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    .ys-body-left {
      width: 444px;
      height: 605px;
    }
    .ys-body-middle {
      width: calc(100% - 944px);
      height: 605px;
      position: relative;
    }
    .ys-body-right {
      width: 444px;
      height: 605px;
    }
  }
  .ys-footer {
    width: 100%;
  }
}
.ys-body-title {
  width: 444px;
  height: 48px;
  background-image: url(../assets/images/ys/titlebg.png);
  background-size: 470px 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    padding-left: 40px;
    font-family: "FZLanTingHeiS-DB1-GBK";
    font-size: 24px;
    letter-spacing: 3.3px;
    font-weight: 400;
    background: linear-gradient(#ffffff, #78d9ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.ys-body-num {
  width: 100%;
  margin-top: 24px;
  .ys-body-num-ul {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ys-body-num-li {
      width: 205px;
      height: 98px;
      background-image: url(../assets/images/ys/numbg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 0 0 0 11px;
      display: flex;
      align-items: center;
      .ys-body-num-li-r {
        margin-left: 10px;
        h4 {
          height: 23px;
          opacity: 1;
          color: #ffffff;
          text-align: left;
          font-size: 16px;
          font-weight: 300;
          font-family: "PingFang SC";
        }
        div {
          margin-top: 5px;
          height: 40px;
          span:first-child {
            font-size: 30px;
            font-weight: 700;
            background: linear-gradient(#eeeeee, #009bfd);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          span:last-child {
            background: none;
            color: #cccccc;
            text-align: left;
            font-size: 12px;
            font-weight: 300;
            font-family: "PingFang SC";
            margin-left: 4px;
          }
        }
      }
    }
  }
}
.ys-body-order {
  margin-top: 40px;
  width: 100%;
  height: 270px;
  //   background: linear-gradient(
  //     151.3deg,
  //     rgb(2, 127, 204) 0%,
  //     rgb(8, 84, 139) 45%,
  //     rgb(0, 68, 99) 100%
  //   );
  background-color: #043154;
  // backdrop-filter: blur(32.64px);
  .ys-body-order-head {
    width: 100%;
    height: 45px;
    background-color: #044979;
    display: flex;
    align-items: center;
    .ys-body-order-li {
      color: rgba(26, 215, 255, 1);
    }
  }
  .seamless-warp {
    width: 100%;
    height: 225px;
    overflow: hidden;
  }
  .ys-body-order-li {
    font-size: 14px;
    width: 25%;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  .ys-body-order-ul {
    display: flex;
    align-items: center;
    width: 100%;
    height: 45px;
    .ys-body-order-li {
      color: rgb(255, 255, 255);
      font-weight: 100;
    }
  }
  .ys-body-order-ul-active {
    background: #0d3757;
  }
}
.ys-body-middle-honor {
  position: absolute;
  left: 220px;
  top: 18px;
  .ys-body-middle-honor-ul {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ys-body-middle-honor-li {
    display: inline-block;
    padding: 0 20px;
    background-image: url(../assets/images/ys/honorbg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    span {
      font-family: "FZLanTingHeiS-DB1-GBK";
      font-weight: 400;
      background: linear-gradient(#fdf6ed, #f98100);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
.ys-body-middle-mapNum {
  width: 50%;
  position: absolute;
  bottom: 10px;
  left: 150px;
  .ys-body-middle-mapNum-ul {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 13px;
    .ys-body-middle-mapNum-img {
      width: 12px;
      margin-right: 20px;
    }
    .ys-body-middle-mapNum-li {
      margin-right: 35px;
      display: flex;
      align-items: flex-end;
      h4 {
        font-size: 12px;
        color: rgb(255, 255, 255);
        width: 24px;
        padding: 2px 0;
        font-weight: 100;
      }
      p {
        margin-left: 10px;
        span {
          line-height: 1;
        }
        span:first-child {
          font-size: 16px;
          font-weight: 700;
          background: linear-gradient(#eeeeee, #009bfd);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        span:last-child {
          background: none;
          color: #cccccc;
          text-align: left;
          font-size: 12px;
          font-weight: 300;
          font-family: "PingFang SC";
          margin-left: 4px;
        }
      }
    }
  }
}
.ys-zd {
  width: 100%;
  margin-top: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  .ys-zd-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
      span {
        line-height: 1;
      }
      span:first-child {
        font-size: 32px;
        font-weight: 700;
        background: linear-gradient(#eeeeee, #009bfd);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      span:last-child {
        background: none;
        color: #cccccc;
        text-align: left;
        font-size: 14px;
        font-weight: 300;
        font-family: "PingFang SC";
        margin-left: 10px;
      }
    }
    h4 {
      font-size: 16px;
      font-weight: 300;
      color: #fff;
    }
  }
}
.ys-fa {
  width: 100%;
  height: 200px;
  position: relative;
  .ys-fa-bg {
    position: absolute;
    top: 68px;
    left: 29px;
  }
  .ys-fa-title {
    position: absolute;
    top: 160px;
    left: 112px;
    color: #fff;
    font-size: 18px;
    font-weight: 100;
  }
}
.ys-fa-legend {
  position: absolute;
  right: 55px;
  top: 30px;
  .ys-fa-legend-li {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    div {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 5px;
    }
    p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
    }
  }
  .li-1 {
    div {
      background-color: #2a9cff;
    }
  }
  .li-2 {
    div {
      background-color: #ff4069;
    }
  }
  .li-3 {
    div {
      background-color: #27e89e;
    }
  }
  .li-4 {
    div {
      background-color: #ffd938;
    }
  }
  .li-5 {
    div {
      background-color: #8355f7;
    }
  }
  .li-6 {
    div {
      background-color: #55e1f7;
    }
  }
}
.ys-pics {
  margin-top: 10px;
  width: 418px;
  height: 203px;
  background: #043358;
  border: 2px solid #1263a6;
  padding: 10px 13px;
  .ys-pics-main {
    width: 418px;
    height: 203px;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    .textDesc {
      width: 100%;
      height: 37px;
      line-height: 37px;
      position: absolute;
      bottom: 0;
      z-index: 1;
      background-color: rgba(14, 47, 83, 0.67);
      p {
        font-family: "FZLanTingHeiS-DB1-GBK";
        font-weight: 300;
        background: linear-gradient(#fff, #78d9ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 18px;
        letter-spacing: 3px;
        text-align: center;
      }
    }
  }
}
.ys-footer-title {
  width: 100%;
  text-align: center;
  background: linear-gradient(#ffffff, #78d9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-weight: 600;
  padding: 6px 0 0 10px;
}
.ys-footer-cases {
  box-sizing: border-box;
  width: 100%;
  height: 308px;
  padding: 0 28px;
  margin-top: 20px;
  position: relative;
  .ys-footer-cases-ul {
    width: 100%;
    height: 308px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ys-footer-cases-li {
      width: 350px;
      height: 308px;
      background-image: url(../assets/images/ys/casebg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      .ys-footer-cases-li-hy {
        width: 302px;
        height: 27px;
        background-image: url(../assets/images/ys/casehybg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 20px;
        font-size: 18px;
        color: #fff;
        font-weight: 100;
        font-family: "FZLanTingHeiS-DB1-GBK";
        letter-spacing: 3px;
        line-height: 27px;
        text-align: center;
      }
      .ys-footer-cases-li-name {
        font-size: 24px;
        background: linear-gradient(#ffffff, #78e2ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-family: "FZLanTingHeiS-DB1-GBK";
        letter-spacing: 3px;
        margin-top: 22px;
      }
      .ys-footer-cases-li-des {
        color: #fff;
        font-size: 16px;
        margin-top: 24px;
        font-weight: 100;
      }
      .ys-footer-cases-li-img {
        width: 286px;
        height: 142px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
}
.ys-footer-cases-main {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
}
</style>
